import { render, staticRenderFns } from "./ProfileSecurity.vue?vue&type=template&id=04ac155c&"
import script from "./ProfileSecurity.vue?vue&type=script&lang=js&"
export * from "./ProfileSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports